import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import AdminLogin from "./Components/AdminLogin";
import AdminLayout from "./Components/AdminLayout";
import ModeratorPanel from "./pages/ModeratorPanel";
import { getRouterBaseName } from "./utils/routing";
import { ADMIN_SESSION_EXPIRED_EVENT } from "./api/errors";

function AppWrapper() {
  const navigate = useNavigate();

  useEffect(() => {
    const handler = (event: Event) => {
      const custom = event as CustomEvent<{ status?: number }>;
      const status = custom.detail?.status;
      if (typeof status === "number" && status !== 401) {
        return;
      }
      navigate("/admin/login", { replace: true });
    };

    window.addEventListener(ADMIN_SESSION_EXPIRED_EVENT, handler);
    return () => {
      window.removeEventListener(ADMIN_SESSION_EXPIRED_EVENT, handler);
    };
  }, [navigate]);

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/admin" />} />
      <Route path="/login" element={<Navigate to="/admin/login" replace />} />
      <Route
        path="/admin/login"
        element={
          <AdminLogin
            onLoginSuccess={() => navigate("/admin")}
            title="Admin Girisi"
            allowedRoles={["admin", "supermoderator", "moderator", "creator"]}
          />
        }
      />
      <Route path="/admin" element={<Navigate to="/admin/ops?tab=dashboard" replace />} />
      <Route path="/admin/*" element={<AdminLayout />} />
      <Route
        path="/moderation/login"
        element={
          <AdminLogin
            title="Moderasyon Girisi"
            description="Moderator veya SuperModerator hesabinizla giris yapabilirsiniz."
            allowedRoles={["admin", "moderator", "supermoderator"]}
            onLoginSuccess={() => navigate("/moderation")}
          />
        }
      />
      <Route path="/moderation" element={<ModeratorPanel />} />
      <Route path="*" element={<div className="p-10 text-center text-red-600">404 - Sayfa bulunamadi</div>} />
    </Routes>
  );
}

export default function App() {
  const baseName = getRouterBaseName();
  return (
    <Router basename={baseName}>
      <AppWrapper />
    </Router>
  );
}
